import React, { useEffect, useState, useMemo } from "react";
import { Table, Checkbox, Button } from "antd";
import "jspdf-autotable";
import { InputCustom } from "../componentes/inputComponent";
import { columnsM } from "./columnsGrupos/columnsArmadoGrupos";
import { FaRegTrashAlt } from "react-icons/fa";

export const TablaArmadoGrupos = ({
  fetchDatos,
  elScroll,
  columns,
  tituloPDF,
  rowKey,
  idAsociacion,
  tituloBanner = "",
  idCategoria,
  todosPilotos,
  modoColorFondo,
  ordenSalida,
  mostrarInput = false,
  onChangeSeleccionados = () => {},
  nombreGrupo,
  onChangeNombre,
  onEliminarGrupo,
  cantGrupos,
}) => {
  // console.log("datos", nombreGrupo)
  const [filtrosPilotos, setFiltrosPilotos] = useState({ desde: "", hasta: "" });
  const [pilotosSeleccionados, setPilotosSeleccionados] = useState([]);
  // console.log("lo q llega", fetchDatos)

  const datosFiltradosPorOrden = useMemo(() => {
    let datos = [...fetchDatos];

    const desde = parseInt(filtrosPilotos.desde);
    const hasta = parseInt(filtrosPilotos.hasta);

    if (!isNaN(desde) && !isNaN(hasta)) {
      datos = datos.filter(
        (item) => item.orden >= desde && item.orden <= hasta
      );
    }

    return datos;
  }, [fetchDatos, filtrosPilotos]);

  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    overflow: "auto",
  };

  useEffect(() => {
    onChangeSeleccionados(pilotosSeleccionados);
  }, [pilotosSeleccionados]);

  useEffect(() => {
    if (todosPilotos) {
      const todosLosIds = datosFiltradosPorOrden.map((item) => item.id_piloto);
      setPilotosSeleccionados(todosLosIds);
    } else {
      setPilotosSeleccionados([]);
    }
  }, [todosPilotos, datosFiltradosPorOrden]);


  const columnasConCheck = useMemo(() => {
    return [
      {
        title: "CHECK",
        key: "seleccionar",
        dataIndex: "id_piloto",
        width: "20px",
        align: "center",
        render: (id_piloto) => (
          <Checkbox
            checked={pilotosSeleccionados.includes(id_piloto)}
            onChange={(e) => {
              setPilotosSeleccionados((prev) => {
                if (e.target.checked) {
                  return [...prev, id_piloto];
                } else {
                  return prev.filter((id) => id !== id_piloto);
                }
              });
            }}
          />
        ),
      },
      ...columns,
    ];
  }, [columns, pilotosSeleccionados]);

  return (
    <div style={containerStyle}>
      {/* Contenedor para los botones */}
      <div
        style={{
          display: "flex",
          flexDirection: "column", //
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <div>

        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            gap: "10px"
          }}
        >
          <div 
            style={{ 
              display: "flex", 
              gap: "10px", 
              marginTop: "0", 
              width: mostrarInput ? "100%" : "none", 
              // justifyContent: mostrarInput ? "flex-end" : "none", 
              alignItems: "end",
              marginBottom: 10
            }}
          >
            {/* Botón para exportar a PDF (solo si mostrarBoton es true) */}
            {mostrarInput && (
              <>
                <InputCustom
                  idCampo="nombre_grupo"
                  nombreCampo="Nombre de grupo"
                  tipo="text"
                  elValue={nombreGrupo}
                  onChange={(e) => onChangeNombre(e.target.value)}
                  elPlaceholder="Ingrese el nombre del grupo"
                  style={{
                    width: "100%",
                  }}
                />
                {cantGrupos > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center"
                    }}
                  >
                    <Button
                      onClick={onEliminarGrupo}
                    >
                      <FaRegTrashAlt
                        className="iconos-tablas"
                        style={{ color: "red", cursor: "pointer", width: 15 }}
                      />
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        <Table
          translate="no" 
          className="notranslate"
          rowKey={rowKey ? rowKey : "id"}
          dataSource={datosFiltradosPorOrden}
          columns={columnasConCheck}
          loading={false}
          scroll={elScroll}
          size="small"
          rowClassName={() => "custom-row"}
          style={{ width: "100%",overflowX: "scroll" }}
        />
      </div>
    </div>
  );
};